import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';

const BenefitsSection: React.FC = () => {
  return (
    <section className="benefits-section py-5">
      <Container>
        <h2 className="text-center mb-5 fw-bold fs-2">Proven Results for SaaS Businesses</h2>
        <Row>
          <Col md={4}>
            <Card className="benefit-card">
              <CardBody>
                <h3>80% Faster Onboarding</h3>
                <p>Quickly onboard new tenants with automated setup and configuration.</p>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="benefit-card">
              <CardBody>
                <h3>90% Uptime Guarantee</h3>
                <p>Ensure reliability with our scalable, high-availability infrastructure.</p>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="benefit-card">
              <CardBody>
                <h3>100% Secure</h3>
                <p>Protect your data with advanced encryption and compliance standards.</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BenefitsSection;
